import { Component, EventEmitter, Output } from '@angular/core';
import { BaseFormDirective } from 'src/app/directives/base-form.directive';

@Component({
  selector: 'app-support-help-form',
  templateUrl: './support-help-form.component.html',
  styleUrls: ['./support-help-form.component.sass']
})
export class SupportHelpFormComponent extends BaseFormDirective {
  override title = 'ENV.SUPPORT-HELP'
  override form = {
    user_id: null,
    city_id: null,
    wall_id: null,
    eps_id: null,
    date_: null,
    phone: null
  }
  path = 'support'

  message = 'ENV.SUPPPORT-MESSAGE'

  @Output() closeSidebar = new EventEmitter()


  override onLanguageInit() {
    super.onLanguageInit();
    this.data.load('city')
    this.data.load('wall')
    this.data.load('eps')
  }

  override getItemEdit() {
    this.editService = this.data.core.cityUnique(this.editId)
    super.getItemEdit()
  }

  override setSubmitMethods(): void {
    this.postService = this.data.core.supportCreate(this.formSanitized)
    this.putService = this.data.core.supportUpdate(this.editId, this.formSanitized)
  }

  override onSubmit(): void {
    this.form.date_ = this.utils.dateToFormat(this.form.date_, 'yyyy-MM-dd')
    this.form.user_id = this.utils.global.user.user_id
    super.onSubmit()
  }


  handleSave(data?: any): void {
    this.processing = false
    this.utils.hideLoad()
    this.utils.toast.saved(this.message)
    this.closeSidebar.emit()
    if (this.editId <= 0) {
      this.cleanForm()
    }
  }

}
